import { render, staticRenderFns } from "./GroupAccordion.vue?vue&type=template&id=3427fcd3&scoped=true&"
import script from "./GroupAccordion.vue?vue&type=script&lang=js&"
export * from "./GroupAccordion.vue?vue&type=script&lang=js&"
import style0 from "./GroupAccordion.vue?vue&type=style&index=0&id=3427fcd3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3427fcd3",
  null
  
)

export default component.exports